const formatValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};

const escapeCsvValue = (value) => {
  const formatted = formatValue(value).replace(/"/g, '""');
  return `"${formatted}"`;
};

const buildCsv = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return "";
  }

  const headers = Array.from(
    rows.reduce((keys, row) => {
      Object.keys(row || {}).forEach((key) => keys.add(key));
      return keys;
    }, new Set())
  );

  const csvRows = [
    headers.map(escapeCsvValue).join(","),
    ...rows.map((row) => headers.map((header) => escapeCsvValue(row?.[header])).join(",")),
  ];

  return csvRows.join("\n");
};

const downloadFile = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const createTimestamp = () => new Date().toISOString().slice(0, 10);

export const downloadJson = (rows, baseFilename) => {
  downloadFile(JSON.stringify(rows ?? [], null, 2), `${baseFilename}-${createTimestamp()}.json`, "application/json");
};

export const downloadCsv = (rows, baseFilename) => {
  downloadFile(`\uFEFF${buildCsv(rows ?? [])}`, `${baseFilename}-${createTimestamp()}.csv`, "text/csv;charset=utf-8;");
};
